<h1 mat-dialog-title>Profile: {{data.label}}</h1>
<div mat-dialog-content>
  <mat-form-field>
    <mat-label>Price</mat-label>
    <input matInput type="number" [(ngModel)]="data.price">
  </mat-form-field>
  <div *ngIf="data.capabilities == null || data.capabilities.length === 0">
    No Capabilities
  </div>
  <div *ngFor="let capability of data.capabilities;let capabilityIndex = index;"
       [ngStyle]="capabilityIndex % 2 === 0 ? {'background':'#BBBBBB'} : {'background':'#999999'}">
    {{capability.label}} <mat-checkbox [(ngModel)]="capability.enabled" style="float: right"></mat-checkbox>
    <div *ngIf="capability.enabled">
      <div *ngFor="let context of capability['contexts'];let contextIndex = index"
           [ngStyle]="contextIndex % 2 === 1 ? {'background':'#CCCCCC', 'margin-left': '20px'} : {'background':'#EEEEEE', 'margin-left': '20px'}">
        {{context.label}} <mat-checkbox [(ngModel)]="context.enabled" style="float: right"></mat-checkbox>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Confirm</button>
</div>
